import CheckboxMui from '@mui/material/Checkbox';

export const Checkbox = ({ inputProps, slotProps, ...props }) => {
    return (
        <CheckboxMui
            sx={{
                color: 'var(--text-secondary)',
                '&.Mui-checked': {
                    color: 'var(--primary-main)',
                },
                '&.MuiCheckbox-indeterminate': {
                    color: 'var(--primary-main)',
                },
                '&.Mui-disabled': {
                    color: 'var(--text-tertiary)',
                },
            }}
            {...props}
            slotProps={{ input: inputProps, ...slotProps }}
        />
    );
};
